import { Component, ViewChild, Injector, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';
import { GetLocationsForViewDto, LocationsDto } from '@shared/service-proxies/service-proxies';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
    selector: 'viewLocationsModal',
    templateUrl: './view-locations-modal.component.html'
})
export class ViewLocationsModalComponent extends AppComponentBase {

    @ViewChild('createOrEditModal', { static: true }) modal: ModalDirective;
    @Output() modalSave: EventEmitter<any> = new EventEmitter<any>();

    active = false;
    saving = false;

    item: GetLocationsForViewDto;


    constructor(
        injector: Injector
    ) {
        super(injector);
        this.item = new GetLocationsForViewDto();
        this.item.locations = new LocationsDto();
    }

    show(item: GetLocationsForViewDto): void {
        this.item = item;
        this.active = true;
        this.modal.show();
    }

    close(): void {
        this.active = false;
        this.modal.hide();
    }
}
